import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';

class Stacks extends Component {
    removeStack(key) {
        this.props.dispatch(Action.do('removeNonControlledStack', key));
    }

    getStackLabel(stack) {
        let str = `Stack ${stack.stackMode} ${1 < stack.stackMode ? 'teams' : 'team'} in ${stack.exposure}% of lineups where `;

        let groups = [];
        Object.keys(stack.groups).map((groupNumber) => {
            let group = stack.groups[groupNumber];
            let str = `${group.playersQuantity} players from ${group.team} of `;

            let arr = [];
            group.lineGroups.map((lineGroup) => {
                arr.push(`L${lineGroup}`);
            });
            group.ppLines.map((ppLine) => {
                arr.push(`PP${ppLine}`);
            });

            str += arr.join(' ');

            groups.push(str);
        });

        str += groups.join(' with ');

        return str;
    }

    render() {
        let {stacks} = this.props;

        return (
            <div className="stacks-box advanced-tags">
                {Object.keys(stacks.list).map((key) => {
                    let stack = stacks.list[key];
                    return (
                        <span key={key} className="advanced-tag">
                            {this.getStackLabel(stack)}
                            <span onClick={() => ::this.removeStack(key)} className="tag-remove"></span>
                        </span>
                    );
                })}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {stacks} = state;
    return {
        stacks: stacks.nonControlled,
    };
}

export default connect(mapStatesToProps)(Stacks);
